const INRaepayOptions = [
    {value: "UJJIVN", label: "UJJIVAN BANK"},
    {value: "IDBIBK", label: "IDBI BANK"},
    {value: "HDFCBK", label: "HDFC BANK"},
    {value: "ICICI", label: "ICICI BANK"},
    {value: "ICCCORP", label: "ICCCORP"},
    {value: "AXIS", label: "AXIS BANK"},
    {value: "PNB", label: "PUNJAB NATIONAL BANK"},
    {value: "CANARA", label: "CANARA BANK"},
    {value: "KOTAK", label: "KOTAK MAHINDRA BANK"},
    {value: "SBI", label: "STATE BANK OF INDIA"},
    {value: "INDIAN", label: "INDIAN BANK"},
    {value: "JKBK", label: "JAMMU & KASHMIR BANK"},
    {value: "INDUSIND", label: "INDUSIND BANK"},
    {value: "BANDHAN", label: "BANDHAN BANK"},
    {value: "IDFC", label: "IDFC BANK"},
    {value: "IOB", label: "INDIAN OVERSEAS BANK"},
    {value: "CITIBANK", label: "CITIBANK INDIA"},
    {value: "UCO", label: "UCO BANK"},
    {value: "MAHARASHTRA", label: "BANK OF MAHARASHTRA"},
    {value: "ANDHRA", label: "ANDHRA BANK"},
    {value: "SYNDICATE", label: "SYNDICATE BANK"},
    {value: "FEDERAL", label: "FEDERAL BANK"},
    {value: "UNION", label: "UNION BANK OF INDIA"},
    {value: "CENTRAL", label: "CENTRAL BANK OF INDIA"},
    {value: "YES", label: "YES BANK"},
    {value: "KARNATAKA", label: "KARNATAKA BANK"},
    {value: "STAN", label: "STANDARD CHARTERED BANK"},
    {value: "BOI", label: "BANK OF INDIA"},
    {value: "PAYTMBK", label: "PAYTM PAYMENTS BANK LTD"},
    {value: "ESFB", label: "EQUITAS SMALL FINANCE BANK"},
    {value: "IPO", label: "INDIAN POST PAYMENT BANK"},
    {value: "DBS", label: "DBS BANK"},
    {value: "RATNAKAR", label: "RATNAKAR BANK"},
    {value: "CATHOLIC", label: "CATHOLIC SYRIAN BANK"},
    {value: "CUB", label: "CUB BANK"},
    {value: "DCB", label: "DCB BANK"},
    {value: "DHANLAXMI", label: "DHANLAXMI BANK"},
    {value: "KARUR", label: "KARUR VYSYA BANK"},
    {value: "BARODA", label: "BANK OF BARODA"},
    {value: "AIRTEL", label: "AIRTEL BANK"},
    {value: "SIB", label: "SOUTH INDIAN BANK"},
    {value: "SIDBI", label: "SMALL INDUSTRIES DEVELOPEMENT BANK OF INDIA"},
    {value: "KERALA", label: "KERALA GRAMIN BANK"},
    {value: "BHARAT", label: "BHARAT BANK"},
    {value: "MIZORAM", label: "MIZORAM RURAL BANK"},
    {value: "APGVB", label: "ANDHARA PRADESH GRAMEENA VIKAS BANK"},
    {value: "INDUSBK", label: "INDUS BANK"},
    {value: "BHARATPE", label: "BHARATPE"},
    {value: "SMBC", label: "THE SUMITOMO BANK"},
    {value: "STCB", label: "STATE BANK OF MAURITIUS"},
    {value: "SOGE", label: "SOCIETE GENERALE"},
    {value: "MSHQ", label: "MASHREQ BANK"},
    {value: "KRTH", label: "KRUNG THAI BANK PUBLIC CO"},
    {value: "INGBPHMM", label: "ING BANK NV"},
    {value: "HSBC", label: "HSBC"},
    {value: "CTBC", label: "CHINA TRUST COMMERCIAL BANK"},
    {value: "BNPA", label: "BNP PARIBAS"},
    {value: "BARC", label: "BARCLAYS BANK PLC"},
    {value: "BOTM", label: "BANK OF TOKYO-MITSUBISH"},
    {value: "NOSC", label: "BANK OF NOVA SCOTIA"},
    {value: "BCEY", label: "BANK OF CEYLON"},
    {value: "BBKM", label: "BANK OF BAHRAIN KUWAIT BSC"},
    {value: "ANZB", label: "ANZ GRINDLAYS BANK"},
    {value: "ADCB", label: "ABU DHABI COMMERCIAL BANK"},
    {value: "SCBL", label: "AMERCIAN EXPRESS BANK"},
    {value: "ABNA", label: "ABN-AMRO BANK NV"},
    {value: "TMBL", label: "TAMILNADU MERCANTILE BANK"},
    {value: "NTBL", label: "NANITAL BANK"},
    {value: "DBSS", label: "LAKSHMI VILAS BANK"},
    {value: "VYSA", label: "ING VYSYA BANK LTD"},
    {value: "CIUB", label: "CITY UNION BANK"},
    {value: "SBTR", label: "STATE BANK OF TRAVANCORE"},
    {value: "STBP", label: "STATE BANK OF PATIALA"},
    {value: "SBMY", label: "STATE BANK OF MYSORE"},
    {value: "FINO", label: "FINO PAYMENTS BANK"},
    {value: "SBHY", label: "STATE BANK OF HYDERABAD"},
    {value: "SBBJ", label: "STATE BANK OF BIKANER JAIPUR"},
    {value: "SBIN", label: "STATE BANK OF INDIA"},
    {value: "IBKL", label: "IDBI BANK LIMITED"},
    {value: "VIJB", label: "VIJAYA BANK"},
    {value: "UTBI", label: "UNITED BANK OF INDIA (UBI)"},
    {value: "PSIB", label: "PUNJAB & SIND BANK"},
    {value: "ORBC", label: "ORIENTAL BANK OF COMMERCE"},
    {value: "BKDN", label: "DENA BANK"},
    {value: "CORP", label: "CORPORATION BANK"},
    {value: "BKID", label: "BANK OF INDIA"},
    {value: "AIRP", label: "AIRTEL PAYMENTS BANK"},
    {value: "APGB", label: "ANDHRA PRAGATHI GRAMEENA BANK"},
    {value: "ALLA", label: "ALLAHABAD BANK"},
];

export default INRaepayOptions;
